<template>
  <span
    class="stp-component teacher-stp non-highlightable"
    :data-active-tab="stpData.activeTab"
    :data-teaching-action-id="stpData.teachingActionId"
    :data-teaching-action-name="stpData.teachingActionName"
    :data-teaching-action-url="stpData.teachingActionUrl"
    :data-note="stpData.teachingActionNotes"
  >
    <cv-interactive-tooltip v-if="showTooltip" direction="bottom">
      <!-- STP Icon -->
      <template #trigger>
        <svg-icon name="STP24" kind="richtext" />
      </template>
      <!-- Tooltip content -->
      <template #content>
        <div class="content-wrapper">
          <div class="content-header">
            <a v-if="stpData.teachingActionUrl" :href="stpData.teachingActionUrl" target="_blank">
              {{ stpData.teachingActionName }}
            </a>
            <h6 v-else>{{ stpData.teachingActionName }}</h6>
          </div>
          <div class="content-body">
            {{ stpData.teachingActionNotes }}
          </div>
        </div>
      </template>
    </cv-interactive-tooltip>

    <!-- Just the STP Icon -->
    <svg-icon v-else name="STP24" kind="richtext" />
  </span>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";

// defineOptions({
//   inheritAttrs: false,
// });
const emit = defineEmits(["loaded"]);

// Props
const props = defineProps({
  stpData: { type: Object, default: null },
  showTooltip: { type: Boolean, default: true },
  id: { type: String, default: "0" },
  // eslint-disable-next-line vue/prop-name-casing
  dynamicMountChildMixin_parentComponent: { type: Object, default: null },
  // eslint-disable-next-line vue/prop-name-casing
  dynamicMountChildMixin_isDynamicallyMounted: { type: Boolean, default: false },
});

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});

// Mounted
onMounted(() => {
  emit("loaded", props.id ?? "0");
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";

.stp-component {
  .student-view & {
    display: none;
  }

  .cv-interactive-tooltip {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    vertical-align: sub;

    .bx--tooltip__label .bx--tooltip__trigger {
      margin-left: 0;

      .sls-icon {
        fill: none;
      }
    }
  }

  .sls-icon {
    vertical-align: middle;
    color: $interactive-01;
    // Override fill propety set by Carbon default styling
    fill: none;

    path {
      stroke: currentColor;
    }
  }
}
</style>
